// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3SE7g","title":"Images90_title__208To","images":"Images90_images__1Eoel"};